'use client';

import { PrinterModelSearch } from '@eliadmin/core/src/components/nt/shared/printer-search-model';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/*
 * Figma „Search“ of the empty cart (168:14017): the field and the button side by side (508 px input
 * with a #E2E5DF border, radius 16, 8 px gap, Primary M button) instead of the hero's white pill
 * with the button inside. The search itself is the shared `PrinterModelSearch` (model suggestions →
 * printer category, otherwise the product search); its form is restyled from here until it gets an
 * appearance option (requested from the lead). Focus ring on the input box, as in the hero.
 */
const SPLIT_FIELD = [
  '[&_form]:gap-2 [&_form]:bg-transparent [&_form]:p-0 sm:[&_form]:gap-2',
  '[&_form]:has-[input:focus-visible]:shadow-none',
  '[&_form>span]:h-12 [&_form>span]:gap-3 [&_form>span]:rounded-2xl [&_form>span]:border [&_form>span]:border-[#E2E5DF] [&_form>span]:bg-white [&_form>span]:px-4',
  '[&_form>span]:transition-shadow [&_form>span:has(input:focus-visible)]:border-[#127A26] [&_form>span:has(input:focus-visible)]:shadow-focus',
  '[&_input]:h-full',
  // Phones: the field over a full-width button (the placeholder needs the width).
  'max-sm:[&_form]:flex-col max-sm:[&_form]:items-stretch max-sm:[&_form>span]:flex-none',
].join(' ');

export function EmptySearch({
  labelledBy,
  placeholder,
  submit,
  noResults,
  brandIds,
  className,
}: {
  labelledBy: string;
  placeholder: string;
  submit: string;
  noResults: string;
  brandIds: (number | string)[];
  /** The width – 640 px in the empty cart, the whole column on the 404. */
  className?: string;
}) {
  return (
    <div className={cn('w-full max-w-[640px] text-left', SPLIT_FIELD, className)}>
      <PrinterModelSearch
        labelledBy={labelledBy}
        placeholder={placeholder}
        submit={submit}
        noResults={noResults}
        brandIds={brandIds}
      />
    </div>
  );
}
